import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LobbyStatusBarState } from './lobby-status-bar.reducer';
import * as AppState from '../../../state/app.state';

export interface State extends AppState.State {
    lobbyStatusBar: LobbyStatusBarState;
}

const getStatusBarFeatureState = createFeatureSelector<LobbyStatusBarState>('lobbyStatusBar');

export const getLobbyStatusData = createSelector(
    getStatusBarFeatureState,
    state => state.statusBarData
);
